import React from 'react';
import './ProjectStyle.css'; // Shared CSS for all projects
import projectVideo from '../../Videos/NOVADemo.mp4';

const ProjectTemplate = () => {
  return (
    <div className="project-container">
        <div className="navbar-non-transparent"></div>
        <div className="title">
            <h1>N.O.V.A - Neruo-Optic Versatile Android</h1>
        </div>
      <div className="project-image-section">
        <video className="project-image" controls>
          <source src={projectVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="tools">
        <p><em><strong>Made with: Solidworks, Python, MediaPipe, OpenCV and Arduino</strong></em></p>
      </div>

        <div className="project-content">
            <section className="project-section">
                <h2>Overview</h2>
                <p>
                N.O.V.A is a robotic hand capable of tracking human hand movements and mimicking them. Made up of 70+ pieces, driven by six servo motors (1 for the wrist, 5 for the fingers) and an Arduino, N.O.V.A is powered by a Python script using MediaPipe’s advanced hand-tracking library. A braided fishing line runs through the fingers and is looped around the servos, allowing the servos to pull the fingers to either bend or straighten. The result is a system that turns simple gestures into seamless mechanical motion!
                </p>
            </section>
        </div>

    </div>
  );
};

export default ProjectTemplate;
